import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/login';
import Feed from './components/feed';
import Admin from './components/admin';
import Register from './components/register';
import ResetPassword from './components/reset-password';
import VerifyEmail from './components/verify-email';
import ProtectedRoute from './components/ProtectedRoute';
import { startWebSocket } from './utils/websocket';

// Check if user is logged in for initial route
const getInitialRoute = () => {
  try {
    const userString = localStorage.getItem('user');
    if (!userString) return '/login';
    const user = JSON.parse(userString);
    if (user && user.isActive) {
      return user.role === 'ADMIN' ? '/admin' : '/feed';
    }
  } catch (error) {
    console.error('Error reading user from localStorage:', error);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  }
  return '/login';
};

function App() {
  useEffect(() => {
    startWebSocket();
  }, []);
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          
          {/* Protected Routes */}
          <Route 
            path="/feed" 
            element={
              <ProtectedRoute allowedRoles={['USER', 'ADMIN']}>
                <Feed />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute allowedRoles={['ADMIN']}>
                <Admin />
              </ProtectedRoute>
            } 
          />
          
          {/* Default Route - Redirect to appropriate page */}
          <Route
            path="/"
            element={<Navigate to={getInitialRoute()} replace />}
          />

          <Route path="/health" element={<span>ok</span>} />

          {/* Catch all route - redirect to appropriate page */}
          <Route
            path="*"
            element={<Navigate to={getInitialRoute()} replace />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
